import { useTranslation } from 'react-i18next';
import type { Trip } from '@ubus/shared';

const STATUS_STYLE: Record<string, { bg: string; color: string }> = {
  scheduled: { bg: '#EFF6FF', color: '#2F80ED' },
  dispatched: { bg: '#DBEAFE', color: '#1D4ED8' },
  in_progress: { bg: '#FEF3C7', color: '#B45309' },
  completed: { bg: '#F3F4F6', color: '#6B7280' },
  cancelled: { bg: '#FEE2E2', color: '#DC2626' },
};

export function DriverStatusPill({ status }: { status: Trip['status'] }) {
  const { t } = useTranslation();
  const style = STATUS_STYLE[status] ?? { bg: '#F3F4F6', color: '#6B7280' };
  const label = t(`task.status.${status}`, { defaultValue: status });
  return (
    <span
      className={`driver-status-pill${status === 'completed' ? ' driver-status-pill--completed' : ''}`}
      style={{ background: style.bg, color: style.color }}
    >
      {label}
    </span>
  );
}

export default DriverStatusPill;
